module.exports = __webpack_public_path__ + "img/0023.b044ef35.gif";